import { render, staticRenderFns } from "./ResendedConciliations.vue?vue&type=template&id=3c1e80b6&lang=pug"
import script from "./ResendedConciliations.vue?vue&type=script&lang=js"
export * from "./ResendedConciliations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports